import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { NakedUl } from '@frontend/design-system';
import { AppointmentListItem } from '../appointment-list-item';
import { AppointmentFloatingActions } from './appointment-floating-actions';

export const AppointmentList = () => {
  return (
    <NakedUl css={listStyle}>
      {/* // TODO: integrate with real data */}
      {Array.from({ length: 10 }).map((_, index) => (
        <li key={index} css={itemContainerStyle}>
          <AppointmentFloatingActions locationId='test' person={{ PersonID: '123' } as any}>
            <AppointmentListItem />
          </AppointmentFloatingActions>
        </li>
      ))}
    </NakedUl>
  );
};

const listStyle = css({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  background: theme.colors.neutral5,
});

const itemContainerStyle = css({
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
  backgroundColor: theme.colors.white,
  transition: 'box-shadow 0.2s ease-in-out',
  ':hover': {
    boxShadow: theme.shadows.light,
    cursor: 'pointer',
  },
});
